export default __webpack_public_path__ + "static/media/ms2.e5c72375.jpeg";